import { OptionalMark } from "@patient-watch/forms";
import { ui } from "@patient-watch/ui";
import { cn } from "@/lib/utils";
import { Controller, useFormContext } from "react-hook-form";
import ReactSlider from "react-slider";

import { glucoseSliderReadings } from "./glucoseSliderReadings";

interface Props {
    name: string;
    label?: string;
    required?: boolean;
}

const GlucoseSlider = ({ name, label, required = false }: Props) => {
    const { control } = useFormContext();

    return (
        <ui.Card data-own-text-size className="flex flex-col justify-center items-center gap-4 mx-auto px-0 w-full">
            <ui.CardHeader>
                <ui.Label className="px-4 font-semibold text-slate-700 text-xl text-center">
                    {label}
                    {!required && <OptionalMark />}
                </ui.Label>
            </ui.CardHeader>
            <ui.CardContent className="flex flex-col gap-y-12 mb-8 w-full">
                <Controller
                    name={name}
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <>
                            <ui.Input
                                min={0}
                                max={30}
                                step={0.1}
                                className={cn(
                                    "flex justify-center items-center m-auto p-auto ring-2 ring-offset-2 w-[110px] h-[70px] font-semibold text-4xl text-center transition-all duration-500 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [appearance:textfield]",
                                    "bg-lime-100 text-lime-800 ring-lime-400",
                                    value > 20 && "bg-red-100 text-red-800 ring-red-400",
                                    value < 5 && "bg-red-100 text-red-800 ring-red-400"
                                )}
                                type="number"
                                value={Math.round(value).toString()}
                                onChange={(e) => onChange(Number(e.target.value))}
                            />
                            <ReactSlider
                                min={0}
                                max={30}
                                step={0.1}
                                value={value}
                                thumbClassName={cn(
                                    "z-10 flex justify-center items-center bg-white -mt-4 border-4 border-indigo-800 rounded-full w-12 h-12 text-center leading-12 hover:scale-110 transition duration-200 cursor-grab"
                                )}
                                trackClassName={cn("bg-indigo-300 px-2 rounded-full h-[15px]")}
                                onChange={(val) => onChange(Math.round(val))}
                                className="w-full"
                            />
                            <p className="flex justify-center items-center text-slate-900 text-lg">
                                {glucoseSliderReadings(value)?.message}
                            </p>
                        </>
                    )}
                />
            </ui.CardContent>
            <ui.CardFooter></ui.CardFooter>
        </ui.Card>
    );
};

export default GlucoseSlider;
